import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Box, Button, Grid, Typography, Tooltip } from '@material-ui/core';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';

import { Tabs, Tab } from '../../../../components/tabs';
import Faceenroll from './FaceEnroll/Faceenroll';
import FaceReportStructure from './FaceReportStructure/FaceReportStructure';

const FaceSetup = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const [choice, setChoice] = useState('Face Enroll');
  const [activeTab, setActiveTab] = useState(1);
  useEffect(() => {
    if (location?.state) {
      setActiveTab(location?.state?.tab);
      /* setStatusFilter(location?.state?.status);
      setStatusType('Pending');
      setChoice(location?.state?.name); */
    } /* else setChoice('Off-Cycle'); */
  }, [location?.state?.activeTab]);
  const onClickTab = (tab) => {
    setChoice(tab);
    resetToInitial();
  };
  const resetToInitial = () => {
    /* showCreateoffcycle(false);
    showEditSelectEmp(false);
    showEditOffcycleModal(false);
    showSelectEmp(false);
    showCompleted(false);
    showBulkImport(false);
    showOvertimeView(false);
    setStatusFilter('');
    setStatusType('');
    setSearchText('');
    resetToPage(); */
  };
  return (
    <>
      <div className="w-full">
        <Tabs activeTab={activeTab}>
          <Tab
            title={t('Face Enroll')}
            onCustomClick={() => {
              onClickTab('Face Enroll');
            }}
          >
            <Faceenroll />
          </Tab>
          <Tab
            title={t('Face ReportStructure')}
            onCustomClick={() => {
              onClickTab('Face ReportStructure');
            }}
          >
            <FaceReportStructure />
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default FaceSetup;
